import { htmlToPlainText } from './htmlToPlainText'
import { markdownToHtml } from './markdownToHtml'

// Plain sentences come back from the markdown pipeline unchanged, yet cost almost a millisecond each, which adds up in
// tables that show a text per cell
const plainSentencePattern = /^[A-Za-z0-9À-ÖØ-öø-ÿ€$§%.,:;?!'"()/–-]+(?: [A-Za-z0-9À-ÖØ-öø-ÿ€$§%.,:;?!'"()/–-]+)*$/
const listMarkerPattern = /^(?:[-+]|\d+[.)])/

export const markdownToPlainText = (markdown: string) => {
    if (plainSentencePattern.test(markdown) && !listMarkerPattern.test(markdown)) {
        return markdown
    }

    return htmlToPlainText(markdownToHtml(markdown))
}
